import React, {useState} from "react";
import {Header} from "../../components/Header";
import {SuperUserNavigationMenu} from "../../components/admin/SuperUserNavigationMenu";
import {Events} from "../../components/admin/Events";
import {Analytics} from "../../components/admin/Analytics";
import {Users} from "../../components/admin/Users";

export const Dashboard = () => {
    const [selectedMenuOption, setSelectedMenuOption] = useState("Analytics");

    const renderContent = () => {
        switch (selectedMenuOption) {
            case "Users":
                return (
                    <Users
                        selectedMenuOption={selectedMenuOption}
                        setSelectedMenuOption={setSelectedMenuOption}
                    />
                )
            case "Events":
                return (
                    <Events
                        selectedMenuOption={selectedMenuOption}
                        setSelectedMenuOption={setSelectedMenuOption}
                    />
                )
            default:
                return (
                    <Analytics
                        selectedMenuOption={selectedMenuOption}
                        setSelectedMenuOption={setSelectedMenuOption}
                    />
                )
        }
    };

    return (
        <div
            className={`bg-[#A20000] flex flex-col justify-end
                min-h-[100dvh] h-[100dvh] max-h-[100dvh] min-w-full w-full max-w-full`}
        >
            {/* Header */}
            <Header/>

            {/*
                portrait:h-[2.5rem] portrait:sm:h-[4rem] portrait:jk:h-[3.5rem]
                landscape:h-[2.5rem] landscape:jk:h-[3.5rem]

                portrait:top-[0.75rem] portrait:inset-x-[0.75rem]
                landscape:top-[0.5rem] landscape:inset-x-[0.5rem]
            */}

            <div
                //     portrait:pt-[4rem] portrait:sm:pt-[5.5rem] portrait:jk:pt-[5rem]
                // landscape:pt-[3.5rem] landscape:jk:pt-[4.5rem]
                // min-w-[100dvw] w-[100dvw] max-w-[100dvw]
                className="flex justify-between portrait:thin-scrollbar portrait:overflow-y-scroll min-w-full w-full max-w-full

                    portrait:min-h-[calc(100dvh-4.75rem)] portrait:sm:min-h-[calc(100dvh-6.25rem)] portrait:jk:min-h-[calc(100dvh-5.75rem)]
                    portrait:h-[calc(100dvh-4.75rem)] portrait:sm:h-[calc(100dvh-6.25rem)] portrait:jk:h-[calc(100dvh-5.75rem)]
                    portrait:max-h-[calc(100dvh-4.75rem)] portrait:sm:max-h-[calc(100dvh-6.25rem)] portrait:jk:max-h-[calc(100dvh-5.75rem)]

                    landscape:min-h-[calc(100vh-3.5rem)] landscape:jk:min-h-[calc(100vh-4.5rem)]
                    landscape:h-[calc(100vh-3.5rem)] landscape:jk:h-[calc(100vh-4.5rem)]
                    landscape:max-h-[calc(100vh-3.5rem)] landscape:jk:max-h-[calc(100vh-4.5rem)]

                    portrait:pb-[0.75rem] portrait:pl-[0.75rem] portrait:pr-[0.75rem]
                    landscape:pb-[0.5rem] landscape:pl-[0.5rem] landscape:pr-[0.5rem]

                    portrait:gap-[0.75rem] landscape:gap-[0.5rem]"
            >
                <SuperUserNavigationMenu
                    selectedMenuOption={selectedMenuOption}
                    setSelectedMenuOption={setSelectedMenuOption}
                />

                <div
                    // portrait:p-[0.4rem] portrait:sm:p-[0.65rem] portrait:jk:p-[0.5rem]
                    //                         landscape:p-[0.4rem] landscape:jk:p-[0.4rem]
                    className="h-full flex-1 overflow-hidden
                        bg-white shadow-xl shadow-black/25
                        landscape:md:block rounded-xl"
                >
                    {renderContent()}
                </div>
            </div>
        </div>
    );
}
